
export enum ApiAuthTypeCd {
	APPLICATION = 'Application',
	APPLICATION_AND_APPLICATION_USER = 'ApplicationAndApplicationUser',
	APPLICATION_USER = 'ApplicationUser',
	NONE = 'None'}

